import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M6.6,3c0,9,10.8,9,10.8,18"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M17.4,3c0,9-10.8,9-10.8,18"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M6.64,3.9H17.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M7.74,7.5h8.52"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M17.36,20.1H6.64"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M16.2,16.5H7.74"
		})
	]
});
export default SvgTimer;
